<template >
  <div style="height:100%;">
    <v-layout row wrap justify-center style="height:100%; background-color:#222">
      <v-flex style="width:3.5%;background-color:#1d1d1d; height:100%;">
        <left-panel
          v-bind:activeTab="active"
          v-bind:model="model"
          v-bind:editor="editor"
          v-bind:logicNodeType="logicNodeType"
          v-bind:removeAnimation="removeAnimation"
          v-bind:selectedAnimation="selectedAnimation"
          v-bind:diagram="diagram"
          v-bind:diagramData="diagramData"
          v-bind:currentNode="currentNode"
          v-bind:saveTimeline="saveTimeline"
          v-bind:getTimelineById="getTimelineById"
          v-bind:worldScaleFactor="worldScaleFactor"
          v-on:updateTimelineId="changeTimelineId"
        ></left-panel>
      </v-flex>
      <v-flex xs2 offset-3 style="position:absolute; z-index:11;right:320px;top:-30px" v-if="savedChanges">
            <span style="color: #e6ede7">Your changes are saved</span>
      </v-flex>
      <v-flex style="width:79%;">
        <v-layout column>
          <v-flex style="width:100%;">
            <v-layout row wrap fill-height justify-center="" >
              <v-flex style="width:100%;" ref="tab">
                <v-tabs
                  v-model="active"
                  color="#1d1d1d"
                  dark
                  slider-color="#c95b6e"
                >
                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.title"
                    ripple
                  >
                    {{tab.title}}
                  </v-tab>
                  <conversation
                    :diagramData="diagramData"
                    :getTimelineById="getTimelineById"
                    :editor="editor"
                    :storyID="storyID"
                    :diagram="diagram"
                    v-on:deSelectTheNode="deSelectTheNode"
                  >
                  </conversation>
                  <v-flex style="max-width:10%">
                    <v-text-field v-model="worldScaleFactor" label="Scale Factor"></v-text-field>
                  </v-flex>
                  <v-spacer>
                  </v-spacer>
                  <v-tab
                    ripple v-show="timelineId && this.currentNode && this.currentNode.data.category === 'Scene'"
                  >
                    Preview
                  </v-tab>
                  <v-tab-item>
                    <vue-progress-bar></vue-progress-bar>
                    <v-card flat row>
                      <v-layout row wrap justify-center style="height:100%; background-color:#222">
                        <v-flex v-show="active === 0">
                          <gojs-tree xs12 class="timelineBorderRadius" ref="diag"
                            v-bind:currentNode="currentNode"
                            v-bind:model-data="diagramData"
                            v-on:model-changed="modelChanged"
                            v-on:changed-selection="changedSelection"
                            v-on:selection-deleted="selectionDeleted"
                            v-on:paste-selection="pasteSelection"
                            v-on:selection-deleting="selectionDeleting"
                            v-bind:style="{height: tabHeight}">
                          </gojs-tree >
                        </v-flex>
                    </v-layout>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-flex v-bind:style="{height:tabHeight}"> Universals Rules</v-flex>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-flex v-bind:style="{height: tabHeight}">Live Rules</v-flex>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-flex >
                        <v-flex v-if="active === 3 && timelineId">
                          <preview
                            v-bind:animationSelected="selectedAnimation"
                            v-bind:selectedTimeline="selectedTimeline"
                            v-bind:currentNode="currentNode"
                            v-bind:editor="editor"
                            v-bind:style="{height: tabHeight}">
                          </preview>
                        </v-flex>
                      </v-flex>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
              <v-flex v-show="timelineId" id="controls-div" ></v-flex>
            </v-layout>
          </v-flex>
          <v-flex style="width:100%;" v-show="timelineId" id="timeline-div"></v-flex>
          <bottomPanel v-if="currentNode && currentNode.data.category !== 'Scene'"
            v-bind:category="currentNode.data.category"
            v-bind:currentNode="currentNode"
            v-bind:editor="editor"
            v-bind:diagramData="diagramData"
          ></bottomPanel>
        </v-layout>
      </v-flex>
      <v-flex style="width:17.5%;" id="right-sidebar" v-bind:style="{height: sidebarHeight + 'px', 'max-height': sidebarHeight + 'px'}" >
          <!-- <nodeEditorSidebar></nodeEditorSidebar> -->
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog  v-model="showChatDialog"  max-width="400">
        <v-card id="talkMitsuku" style="width:400px; padding:20px" >
          <v-card-title style="padding: 20px 0 10px 30px" class="headline">Talk to Mitsuku</v-card-title>
          <v-flex style="width:300px; margin-left: 30px;"><v-text-field v-model='message' label='Type message here'></v-text-field></v-flex>

          <!-- <v-input v-model='message' placeholder='edit me'> -->
          <v-flex v-for="(res, index) in responsesFromMitsuku" :key="index" style="padding:10px; margin-left:20px">
            <span style="font-size:14px;"><strong style="color:#F06292">Mitsuku Response {{index + 1}} </strong> "{{ res }}" <v-btn text icon class="ma-0" @click.stop.prevent="copyMitsukuResponse(index)">
            <v-icon style=" vertical-align: baseline; font-size:14px; color:#3d3d3d">fas fa-copy</v-icon></v-btn></span>
            <input type="hidden" :id="index" :value="res">
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="showChatDialog = false">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click="talkToMitsuku">Talk</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog  v-model="showSynonymDialog" style="" max-width="400">
        <v-card wrap id="synonyms" style="width:400px;background-color:#fff;" class="pl-4" >
          <v-btn style="position:absolute; right:15px; top:25px" icon dark @click="showSynonymDialog=false"><v-icon color="grey">close</v-icon></v-btn>
          <v-card-title dark class="pt-5" style="color:#303030; font-size:20px; text-transform:uppercase; font-weight:500">Synonyms</v-card-title>
          <v-flex fill-height xs12 v-for="(res, index) in synonymsArray" :key="index" class="pl-3 my-1">
            <v-layout>
              <v-flex xs12 sm8 class="pt-2 mt-1">
                <span style="font-size:14px; vertical-align:middle"><strong style="color:#bf975f; font-size:16px; font-weight:500;">Synonym #{{ index+1 }}</strong>
                <span class="ml-2" style="color:#303030; font-size:15px; text-transform:uppercase">{{ res }}</span></span>
              </v-flex>
              <v-flex xs12 sm4 class="pa-auto" style="">
                <v-btn style="text-transform: none; vertical-align:middle; font-size:15px" text dark round flat outline color="#bf975f" @click.stop.prevent="dispatchToUserTab(index)">add</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="showSynonymDialog = false">Done</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
// import Timeline from '../components/story-edit-view/timeline'
// import Visual from './Visual'
import LeftPanel from '../components/story-edit-view/leftPanel'
import CreateStory from '../components/story-list-view/createStory'
import gojsTree from '../components/story-edit-view/treeview/gojsTree'
import bottomPanel from '../components/story-edit-view/bottomPanel'
import go from 'gojs'
import nodeEditorSidebar from '../components/story-edit-view/nodeEditorSidebar'
import {db, timelinesRef} from '../firebaseDB'
import Editor from '../../external_libs/frame.js/editor/js/Editor'
import Timeline from '../../external_libs/frame.js/editor/js/Timeline'
import Sidebar from '../../external_libs/frame.js/editor/js/Sidebar'
import Controls from '../../external_libs/frame.js/editor/js/Controls'
import { parseExport } from '../data/export-parser'
import request from 'request'
import _ from 'lodash'
import uniqid from 'uniqid'
import Preview from '../components/story-edit-view/preview'
import Conversation from '../components/story-edit-view/conversation/conversation'

// let viewport = new Viewport(editor)
// let menubar = new Menubar( editor );
// document.body.appendChild( menubar.dom );
export default {
  components: {
    nodeEditorSidebar,
    gojsTree,
    CreateStory,
    LeftPanel,
    bottomPanel,
    Preview,
    Conversation
  },
  data () {
    return {
      selectedAnimation: null,
      // for nodestree
      currentNode: null,
      diagramData: null,
      // for tab section
      editor: new Editor(),
      active: 0,
      tabs:
      [
        {
          title: 'Main Story'
        },
        {
          title: 'Univeral Rules'
        },
        {
          title: 'Custom Conditions'
        }
      ],
      diagram: null,
      tabHeight: 40 + 'vh',
      sidebarHeight: screen.height,
      logicNodeType: null,
      // get height of player controls
      controlDivHeight: null,
      // end of tab
      savedModelText: '',
      deletedNode: null,
      // end nodestree
      timelineId: null,
      selectedTimeline: null,
      savedChanges: false,
      showChatDialog: false,
      message: '',
      responsesFromMitsuku: [],
      showSynonymDialog: false,
      synonymsArray: [],
      worldScaleFactor: 1,
      tempTimeLine: null,
      tempCurrentNode: null
    }
  },
  created () {
    this.getAssetsForSound()
    this.getAssetsForVoice()
    this.getAssetsForCharacterAnimations()
    this.getAssetsForSceneExperience()
    this.getAssetsForCharacterModels()
    this.getAssetsForSetOverlays()
    this.getAssetsForSetDesign()
    this.getAssetsForUserCondition()
    this.getAssetsForProps()
    document.addEventListener('keydown', this.keyDownEvent)
    window.onbeforeunload = this.saveTreeToDB
    db.ref(`stories/${this.storyID}`)
        .once('value')
        .then(snapshot => {
          this.story = snapshot.val()
          this.diagramData = this.story.diagramData
          if (this.diagramData.nodeDataArray.find(node => node.category === 'Root').worldScaleFactor) {
            this.worldScaleFactor = this.diagramData.nodeDataArray.find(node => node.category === 'Root').worldScaleFactor
          }
        })
  },

  methods: {
    selectionDeleted () {
      let logicNodes = this.diagram.model.nodeDataArray.filter(node => node.category === 'Logic')

      logicNodes.forEach(logicNode => {
        this.updateNumberOfUserNodes(logicNode)
        this.updateNumberOfSceneNodes(logicNode)
      })
    },
    updateNumberOfUserNodes (logicNode) {
      let linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === logicNode.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)) : []
      let connectedUserNodes = linkedNodes.filter(linkedNode => linkedNode.category === 'User')
      logicNode.selectedValues.find(selectedValue => selectedValue.key === 'numberOfUserNodes').value = connectedUserNodes.length
    },
    updateNumberOfSceneNodes (logicNode) {
      let linksFrom = this.diagram.model.linkDataArray.filter(linkedData => linkedData.from === logicNode.key)
      let linkedNodes = linksFrom.length ? linksFrom.map(link => this.diagram.model.nodeDataArray.find(node => node.key === link.to)) : []
      let connectedUserNodes = linkedNodes.filter(linkedNode => linkedNode.category === 'Scene')
      logicNode.selectedValues.find(selectedValue => selectedValue.key === 'numberOfSceneNodes').value = connectedUserNodes.length
    },
    getPropById (propId) {
      return db.ref('/assets/asset_data/prop/' + propId).once('value').then(snapshot => snapshot.val())
    },
    changeTimelineId (e) {
      this.timelineId = e
    },
    // keyDownEvent (e) {
    //   // backspace key pressed
    //   if (e.keyCode === 8) {
    //     this.removeAnimation()
    //   }
    // },
    removeAnimation () {
      if (this.selectedAnimation) {
        this.editor.removeAnimation(this.selectedAnimation)
        this.selectedAnimation = null
        this.editor.selectAnimation(this.selectedAnimation)
      }
    },
    animationSelected (animation) {
      this.selectedAnimation = animation
    },
    logicNodeTypeChanged (value) {
      if (this.currentNode !== null) {
        this.currentNode.data.logicNodeType = value
        this.logicNodeType = value
      }
    },
    userSectionCheckedParentNode (title, checked) {
      if (checked) {
        this.currentNode.data.enabledParents.push({title: title})
      } else {
        this.currentNode.data.enabledParents = this.currentNode.data.enabledParents.filter(parent => parent.title !== title)
      }
    },
    userSectionValue (sectionData) {
      if (this.currentNode) {
        let indexMatchingNode = this.currentNode.data.selectedValues.findIndex(data => data.id === sectionData.id)
        if (indexMatchingNode !== -1) {
          this.currentNode.data.selectedValues[indexMatchingNode] = sectionData
        } else {
          this.currentNode.data.selectedValues.push(sectionData)
        }
        console.log(this.currentNode.data.selectedValues)
        this.saveTreeToDB()
      }
    },
    userSectionValueRemoved (id) {
      let indexMatchingNode = this.currentNode.data.selectedValues.findIndex(data => data.id === id)
      if (indexMatchingNode !== -1) {
        this.currentNode.data.selectedValues = [...this.currentNode.data.selectedValues.slice(0, indexMatchingNode), ...this.currentNode.data.selectedValues.slice(indexMatchingNode + 1)]
      }
      this.saveTreeToDB()
    },
    getTimelineById (timelineId) {
      return db.ref(`timelines/${timelineId}`).once('value').then(snapshot => snapshot.val())
    },
    getAssetsForSound () {
      db.ref(`assets/asset_data/sound`).once('value').then((snapshot) => {
        let data = snapshot.val()
        this.editor.soundItems = Object.values(data)
      })
    },
    getAssetsForProps () {
      db.ref(`assets/asset_data/prop`).once('value').then((snapshot) => {
        let data = snapshot.val()
        Object.keys(data).forEach(key => (data[key].propId = key))
        this.editor.propItems = Object.values(data)
      })
    },
    getAssetsForVoice () {
      db.ref(`assets/asset_data/voice`).once('value').then((snapshot) => {
        let data = snapshot.val()
        this.editor.voiceItems = Object.values(data)
      })
    },
    getAssetsForUserCondition () {
      db.ref(`assets/asset_data/user/data/`).on('value', (snapshot) => {
        let data = snapshot.val()
        this.editor.userConditionItems = Object.values(data)
      })
    },
    getAssetsForSceneExperience () {
      db.ref(`assets/asset_data/scene_experience`).once('value').then((snapshot) => {
        this.editor.sceneExperiences = snapshot.val()
      })
    },
    getAssetsForCharacterAnimations () {
      db.ref(`assets/asset_data/basic_character_action`).once('value').then((snapshot) => {
        let data = snapshot.val()
        Object.keys(data).forEach(key => { data[key].animationId = key })
        this.editor.animationItems = Object.values(data)
      })
    },
    getAssetsForCharacterModels () {
      db.ref(`assets/asset_data/character_model`).once('value').then((snapshot) => {
        let data = snapshot.val()
        Object.keys(data).forEach(key => { data[key].characterModelId = key })
        this.editor.characterModels = Object.values(data)
      })
    },
    getAssetsForSetDesign () {
      db.ref(`assets/asset_data/set_design`).once('value').then((snapshot) => {
        const data = snapshot.val()
        let vals = Object.values(data)

        let setDesignItems = vals.map(val => {
          if (val.existing_props) {
            let promiseStore = []
            val.existing_props.forEach(prop => {
              promiseStore.push(this.getPropById(prop.id))
            })
            Promise.all(Object.values(promiseStore)).then(data => {
              let fixedProps = data.map((propData, i) => {
                let setDesignPropData = val.existing_props[i]
                if (propData) {
                  propData.defaultPosition = Array.from(setDesignPropData.defaultPosition)
                  propData.defaultRotation = Array.from(setDesignPropData.defaultRotation)
                }
                return propData
              }).filter(propData => propData)
              val.existing_props = fixedProps
            })
          } else {
            val.existing_props = []
          }
          return val
        })
        this.editor.setDesignItems = setDesignItems
      })
    },
    getAssetsForSetOverlays () {
      db.ref(`assets/asset_data/set_overlay`).once('value').then((snapshot) => {
        const data = snapshot.val()
        this.editor.overlayItems = Object.values(data)
      })
    },
    // remove all the Animations and add the curTimeLine's animations
    addItemsToTimelineEditor () {
      // the problem is here
      // the 'selectedTimeline' is not the updated one
      let propsDate = this.selectedTimeline.elements
      // remove all the animations
      let animationsToRemove = [...this.editor.timeline.animations]
      animationsToRemove.forEach(animation => this.editor.removeAnimation(animation))
      this.editor.signals.resetTimeline.dispatch()
      propsDate.forEach(propData => {
        let enabled = true
        this.editor.addAnimation(
          // eslint-disable-next-line no-undef
          new FRAME.Animation(
              propData.id,
              propData.name,
              propData.startTime,
              propData.endTime,
              // eslint-disable-next-line no-undef
              propData.layer, new FRAME.Effect('Effect'),
              enabled,
              propData.type,
              propData.elements,
              propData.origin,
              propData.destination,
              propData.phase,
              propData.assetUrl,
              propData.value
            )
          )
      })
    },
    model () {
      return this.$refs.diag.model()
    },
    // this event listener is declared on the <diagram>
    modelChanged (e) {
      if (e.isTransactionFinished) {  // show the model data in the page's TextArea
        this.savedModelText = e.model
      }
    },
    changedSelection (e) {
      this.saveTreeToDB()
      this.currentNode = null
      this.currentNodeText = ''
      this.timelineId = null

      let node = e.diagram.selection.first()
      if (node instanceof go.Node) {
        this.currentNode = node
        let nodeType = this.currentNode.data.category
        this.getHeight(nodeType)
        this.currentNode.data.checkedFields = this.currentNode.data.checkedFields || []
        this.editor.currentNodeCheckedFields = this.currentNode.data.checkedFields

        this.currentNode.data.selectedValues = this.currentNode.data.selectedValues || []
        this.editor.currentNodeSelectedValues = this.currentNode.data.selectedValues

        this.currentNode.data.enabledParents = this.currentNode.data.enabledParents || []
        this.editor.currentNodeEnabledParents = this.currentNode.data.enabledParents

        this.setUpDataOnNodeByType()

        this.currentNodeText = node.data.title
        this.timelineId = node.data.timelineId
      } else if (node instanceof go.Link) {
        this.currentNode = node
      }
    },
    setUpDataOnNodeByType () {
      const nodeData = this.currentNode.data
      if (nodeData.category === 'Chatbot' && !nodeData.selectedValues.length) {
        this.currentNode.data.selectedValues.push(...this.initChatBotData())
      } else if (nodeData.category === 'User' && !nodeData.selectedValues.length) {
        this.currentNode.data.selectedValues.push(...this.initUserData())
      } else if (nodeData.category === 'Logic' && !nodeData.selectedValues.length) {
        this.currentNode.data.selectedValues.push(...this.initLogicData())
      }
    },
    initChatBotData () {
      return [
        {
          key: 'serviceName',
          value: 'Mitzuku',
          id: uniqid()
        },
        {
          key: 'typeName',
          value: 'Natural',
          id: uniqid()
        },
        {
          key: 'numberOfCalls',
          value: 1,
          id: uniqid()
        },
        {
          key: 'selectedCharacter',
          value: '',
          id: uniqid()
        },
        {
          key: 'characterVoice',
          value: 'en-US-Standard-C.mp3',
          id: uniqid()
        },
        {
          key: 'characterVoiceVolume',
          value: 1,
          id: uniqid()
        },
        {
          key: 'characterAnimation',
          value: 'Stand Idle',
          id: uniqid()
        },
        {
          key: 'characterPosition',
          value: [0, 0, 0],
          id: uniqid()
        },
        {
          key: 'characterRotation',
          value: [0, 0, 0],
          id: uniqid()
        }
      ]
    },
    initUserData () {
      return [
        {
          key: 'type',
          value: 'Verbal',
          id: uniqid()
        },
        {
          key: 'keywords',
          value: [],
          id: uniqid()
        },
        {
          key: 'conditions',
          value: [
            // {
            //   type: 'Verbal',
            //   scaleValue: [0, 0],
            //   stringValue: '',
            //   selectionValue: '',
            //   booleanValue: true,
            //   visualItem: '',
            //   visualItemType: '',
            //   id: uniqid()
            // },
            // {
            //   type: 'Verbal',
            //   scaleValue: [0, 0],
            //   stringValue: '',
            //   selectionValue: '',
            //   booleanValue: true,
            //   visualItem: '',
            //   visualItemType: '',
            //   id: uniqid()
            // }
          ],
          id: uniqid()
        }
      ]
    },
    initLogicData () {
      return [
        {
          key: 'type',
          value: '',
          id: uniqid()
        },
        {
          key: 'conditionType',
          value: '',
          id: uniqid()
        },
        {
          key: 'numberOfUserNodes',
          value: 0,
          id: uniqid()
        },
        {
          key: 'numberOfSceneNodes',
          value: 0,
          id: uniqid()
        },
        {
          key: 'defaultChatbotLine',
          value: '',
          id: uniqid()
        },
        {
          key: 'probabilities',
          value: [],
          id: uniqid()
        },
        {
          key: 'touchType',
          value: '',
          id: uniqid()
        },
        {
          key: 'interaction',
          value: [],
          id: uniqid()
        },
        {
          key: 'direction',
          value: [],
          id: uniqid()
        },
        {
          key: 'nextID',
          index: '',
          value: [],
          id: uniqid()
        }
      ]
    },
    selectionDeleting (e) {
      e.subject.each((p) => {
          // get deleted node
        this.deletedNodeKey = p.part
        let childIt
        let randomPercent = null
        let parent = this.deletedNodeKey.findNodesInto().value
        if (parent !== undefined && parent.data.category === 'Logic') {
          childIt = parent.findLinksOutOf()
          randomPercent = Math.round((100 / (childIt.count - 2)), 2) + '%'
                  // update previous node
          while (childIt.next()) {
            let child = childIt.value
            // update all percentage for children except for chatbot
            if (this.diagram.findNodeForKey(child.data.to).data.category !== 'Chatbot') {
              child.data.text = randomPercent
              child.updateTargetBindings()
            }
          }
        }
      })
    },
    // Here we modify the GoJS Diagram's Model using its methods,
    // which can be much more efficient than modifying some memory and asking
    // the GoJS Diagram to find differences and update accordingly.
    // Undo and Redo will work as expected.
    // render () {
    //   if (this.model() !== null) {
    //     let model = this.model()
    //     model.startTransaction()
    //     model.commitTransaction('render it')
    //   }
    // },
    pasteSelection (e) {
      let nodeTimelineId = e.diagram.selection.first().data.timelineId
      let nodeTitle = e.diagram.selection.first().data.category
      if (e.diagram.model.nodeDataArray.find(nodeData => nodeData.timelineId === nodeTimelineId)) {
        this.getTimelineById(nodeTimelineId).then(timeline => {
          timeline.elements = timeline.elements ? timeline.elements : []
          this.selectedTimeline = timeline
          this.addItemsToTimelineEditor()

          let newTimelineId = timelinesRef.push({
            name: nodeTitle,
            elements: timeline.elements,
            nodeId: timeline.nodeId,
            nodeType: timeline.nodeType}).key

          e.diagram.selection.first().data.timelineId = newTimelineId
          this.timelineId = newTimelineId
        })
      }
    },
    funcPlaceHolder (e) {
      console.log(e.target.innerHTML + ' Clicked')
    },
    getHeight (type) {
      // this.tabHeight = 'calc(' + '40vh' + ' + ' + (48 + this.controlDivHeight + 'px)')
      if (type === 'Scene') {
        this.tabHeight = 40 + 'vh'
      } else {
        // this.tabHeight = screen.height - 64 - this.controlDivHeight + 'px'
        this.tabHeight = 40 + 'vh'
      }
    },
    saveTreeToDB () {
      let rootNode = this.diagramData.nodeDataArray.find(node => node.category === 'Root')
      rootNode['worldScaleFactor'] = parseFloat(this.worldScaleFactor)
      if (this.currentNode) {
        switch (this.currentNode.category) {
          case 'Scene':
            this.tempTimeLine = this.timelineId
            this.tempCurrentNode = this.currentNode
            this.saveTimeline()
            break
          default:
            console.log('Saving ' + this.currentNode.category + ' node information...')
        }
      }
      let updates = {}
      // this.updateLogicNode()
      updates[`stories/${this.storyID}/diagramData`] = this.diagramData // this.$store.state.stories.filter(story => story.key === this.storyID)[0].diagramData.nodeDataArray
      db.ref().update(updates)
          .then(snapshot => {
            this.save = false
            this.savedChanges = true
            if (this.savedChanges === true) {
              setTimeout(() => {
                this.savedChanges = false
              }, 3000)
            }
            console.log('All information saved')
          })
    },
    async getModel (id) {
      if (id) {
        const snapshot = await db.ref('assets/asset_data/character_model/' + id).once('value')
        return {
          iOS: snapshot.val().asset_bundle.iOS.fileURL || 'N/A',
          Android: snapshot.val().asset_bundle.Android.fileURL || 'N/A'
        }
      } else {
        return {
          iOS: 'N/A',
          Android: 'N/A'
        }
      }
    },
    async saveTimeline () {
      // console.log('test')
      if (this.tempCurrentNode && this.tempCurrentNode.data.category === 'Scene' && this.tempTimeLine) {
        const promises = this.editor.timeline.animations.map(async animation => {
          let obj = {
            id: animation.id,
            startTime: animation.start,
            endTime: animation.end,
            name: animation.name,
            type: animation.type,
            origin: animation.origin,
            layer: animation.layer,
            destination: animation.destination,
            elements: animation.elements,
            phase: animation.phase,
            assetUrl: animation.assetUrl,
            iOS: 'N/A',
            Android: 'N/A',
            value: animation.value
          }
          try {
            const { iOS, Android } = await this.getModel(animation.value)
            obj.iOS = iOS
            obj.Android = Android
            return obj
          } catch (error) {
            console.log(`Error - ${error}`)
            return obj
          }
        })
        const elements = await Promise.all(promises)

        this.selectedTimeline.elements = elements
        if (this.tempCurrentNode.key) {
          this.selectedTimeline.nodeId = this.tempCurrentNode.key
        }
        this.selectedTimeline.nodeType = this.tempCurrentNode.category
        db.ref(`timelines/${this.tempTimeLine}`).update(this.selectedTimeline).then(() =>
          console.log('saved timeline : ' + this.tempTimeLine)
        )
      }
    },
    exportFile () {
      let nodeArray = this.diagramData.nodeDataArray
      let linkArray = this.diagramData.linkDataArray
      parseExport(nodeArray, linkArray, this.storyID)
    },
    enableChatDialog () {
      this.showChatDialog = true
    },
    talkToMitsuku () {
      this.responsesFromMitsuku = []
      console.log('you are talking to mitsuku')
      const userKey = 'e700c6f188eedc8c5b3a55cb47a6ca42'
      const api = 'https://aiaas.pandorabots.com/talk/1409618417683/customized'
      let input = _.replace(this.message, '?', '')
      let encodedInput = encodeURI(input)
      var options = {
        url: api + '?input=' + encodedInput + '&user_key=' + userKey,
        method: 'POST'
      }
      let tempArray = []
      let callback = (error, response, body) => {
        if (!error && response.statusCode === 200) {
          console.log(body)
          tempArray.push(JSON.parse(body).responses[0])
          this.responsesFromMitsuku = _.uniq(tempArray)
        }
      }
      for (let i = 0; i < 10; i++) {
        request(options, callback)
      }
    },
    copyMitsukuResponse (index) {
      let responseToCopy = document.getElementById(index)
      responseToCopy.setAttribute('type', 'text')
      responseToCopy.select()

      try {
        document.execCommand('copy')
        // var msg = successful ? 'successful' : 'unsuccessful'
      } catch (err) {
        alert('Oops, unable to copy')
      }

      /* unselect the range */
      responseToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    enableSynonymDialog (arr) {
      this.synonymsArray = arr
      this.showSynonymDialog = true
    },
    dispatchToUserTab (index) {
      let selectedSynonym = this.synonymsArray[index]
      let keywords = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'keywords')
      if (!keywords.value.find(keyword => keyword.value.toLowerCase() === selectedSynonym.toLowerCase())) {
        keywords.value.push(
          {
            key: 'keyword',
            value: selectedSynonym,
            id: uniqid()
          }
        )
      }
    },
    deSelectTheNode () {
      this.diagram.select(this.diagram.findNodeForKey(0))
    }
  },
  mounted () {
    let timeline = new Timeline(this.editor)
    let sidebar = new Sidebar(this.editor)
    let controls = new Controls(this.editor)
    this.diagram = this.$refs.diag.diagram
    console.log(this.diagram.model)
    // this.currentNode = this.diagram.model.
    document.getElementById('timeline-div').appendChild(timeline.dom)
    document.getElementById('right-sidebar').appendChild(sidebar.dom)
    // document.getElementById('preview-div').appendChild(viewPort.dom)
    document.getElementById('controls-div').appendChild(controls.dom)
    this.controlDivHeight = document.getElementById('controls-div').offsetHeight
    this.editor.signals.animationSelected.add(this.animationSelected)
    this.editor.signals.animationPhaseChanged.add(this.saveTimeline)
    // this.editor.signals.animationAdded.add(this.saveTimeline)
    // this.editor.signals.animationRemoved.add(this.saveTimeline)
    // this.editor.signals.animationSelected.add(this.saveTimeline)
    // editor.signals.animationModified.add(this.saveTimeline)
    // this.editor.signals.animationPhaseChanged.add(this.saveTimeline)
    this.editor.signals.animationTypeChange.add(this.saveTimeline)
    this.editor.signals.userSectionCheckedParentNode.add(this.userSectionCheckedParentNode)
    this.editor.signals.logicNodeTypeChanged.add(this.logicNodeTypeChanged)
    this.editor.signals.userSectionValue.add(this.userSectionValue)
    this.editor.signals.userSectionValueRemoved.add(this.userSectionValueRemoved)
    this.editor.signals.enableChatDialog.add(this.enableChatDialog)
    this.editor.signals.enableSynonymDialog.add(this.enableSynonymDialog)
    // document.addEventListener('dragover', function (event) {
    //   event.preventDefault()
    //   event.dataTransfer.dropEffect = 'copy'
    // }, false)
    // document.addEventListener('drop', function (event) {
    //   event.preventDefault()
    //   if (event.dataTransfer.files.length > 0) {
    //     var reader = new FileReader()
    //     reader.addEventListener('load', function (event) {
    //       if (confirm('Any unsaved data will be lost. Are you sure?')) {
    //         editor.clear()
    //         editor.fromJSON(JSON.parse(event.target.result))
    //       }
    //     }, false)
    //     reader.readAsText(event.dataTransfer.files[ 0 ])
    //   }
    // }, false)
    window.addEventListener('resize', () => {
      this.editor.signals.windowResized.dispatch()
    })
    this.editor.signals.windowResized.dispatch()
  },
  watch: {
    timelineId: function () {
      if (this.timelineId) {
        // timelineId changed
        this.$Progress.start()
        this.loading = true
        this.getTimelineById(this.timelineId).then(timeline => {
          timeline.elements = timeline.elements ? timeline.elements : []
          this.selectedTimeline = timeline
          this.addItemsToTimelineEditor()
          this.editor.signals.windowResized.dispatch()
          this.$Progress.finish()
        })
      }
      // editor.signals.nodeSelected.dispatch(this.currentNode)
    },
    currentNode () {
      if (this.currentNode) {
        this.editor.selected = null
        this.editor.signals.nodeSelected.dispatch(this.currentNode)
      }
      this.selectedAnimation = null
    }
  },
  computed: {
    currentNodeText: {
      get () {
        let node = this.currentNode
        if (node instanceof go.Node) {
          return node.data.text
        } else {
          return ''
        }
      },
      set (val) {
        let node = this.currentNode
        if (node instanceof go.Node) {
          let model = this.model()
          model.startTransaction()
          model.setDataProperty(node.data, 'title', val)
          model.commitTransaction('edited text')
        }
      }
    },
    storyID () {
      return this.$route.query.id
    }
  }
}
</script>
<style scoped>
/* only wrote css for specific target */
@import '../../external_libs/frame.js/editor/css/dark.css';
@import '../../external_libs/frame.js/editor/css/main.css';

.borderEditView {
  width: 100%;
  height: 98.5%;
  border: 1px dashed rgb(252, 246, 189);
  margin: 9px 0px 0px 1px;
  padding: 0 10px;
}

.edit-story-wrapper {
  padding-right: 20px;
  padding-top: 0px;
  margin: 0;
  padding: 0px 20px 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/StoryEditView.vue